import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "46",
  height: "40",
  fill: "none",
  viewBox: "0 0 46 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B93E51",
      d: "M45.5 12.198a22.7 22.7 0 0 1-3.653 12.36 32.3 32.3 0 0 1-12.09 11.055L23 39.168l-6.757-3.555a32.3 32.3 0 0 1-12.09-11.055 23 23 0 0 1-1.47-2.64h8.37l.697-.75 4.5 9.75 3.75-13.5 3 4.5h7.163a3 3 0 0 0 2.587 1.5 3 3 0 1 0 0-6c-1.11 0-2.062.608-2.587 1.5H24.5l-5.25-9-3.75 12.75-3.75-7.5-2.302 3.75H1.52c-.038-.09-.06-.187-.09-.277a22.7 22.7 0 0 1-.93-6.443c0-1.995.465-3.96 1.358-5.738A11.38 11.38 0 0 1 12.035.168c2.385 0 4.65.75 6.525 2.055a11.4 11.4 0 0 1 4.163 5.437l.277.758.277-.758a11.4 11.4 0 0 1 4.163-5.437A11.4 11.4 0 0 1 33.965.168a11.38 11.38 0 0 1 10.177 6.293 12.8 12.8 0 0 1 1.358 5.737"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D88593",
      d: "M39.95 1.87A11.34 11.34 0 0 0 33.965.168c-2.385 0-4.65.75-6.525 2.055a11.4 11.4 0 0 0-4.163 5.437L23 8.418l-.277-.758a11.4 11.4 0 0 0-4.163-5.437A11.4 11.4 0 0 0 12.035.168l-.091.003a24.7 24.7 0 0 0-1.694 8.997c0 2.383.339 4.687.967 6.867l.533-.867 3.75 7.5 3.75-12.75 5.25 9h5.663c.524-.892 1.477-1.5 2.587-1.5a3 3 0 1 1 0 6c-1.11 0-2.062-.607-2.587-1.5H23l-3-4.5-2.553 9.191a24.67 24.67 0 0 0 15.298 7.203 32.3 32.3 0 0 0 9.103-9.254 22.7 22.7 0 0 0 3.653-12.36 12.8 12.8 0 0 0-1.358-5.738 11.4 11.4 0 0 0-4.193-4.59"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#B93E51",
      d: "M32.707 4.318c.43-1.547 4.524-2.056 7.573.972 3.048 3.029 2.542 7.128.963 7.566-1.58.438-3.312-1.505-5.166-3.38-1.852-1.874-3.8-3.61-3.37-5.158"
    }, null, -1)
  ])))
}
export default { render: render }